export const ALL_REPOSITORIES = 'instegrations/github/ALL_REPOSITORIES'
